import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { CreateJobRequest, CreateJobWithPartRequest, IAllJobsResponse, IJob, IJobStatsResponse } from "../models/Job";
// import { ISetting, ISettingsResponse } from "../models/Setting";

export default function useJobsByVehicle(vehicleId: string) {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const jobs = useQuery({
    queryKey: ["jobs"],
    queryFn: () => get<IAllJobsResponse>(`/job/vehicle/${vehicleId}`),
    enabled: !!vehicleId,
    staleTime: 1000 * 60 * 10, //10 minutes
  });


  const create = useMutation(
    (job: CreateJobRequest) => post(`/job`, job),
    {
      onSuccess: () => {
        queryClient.refetchQueries(["jobs"]);
        queryClient.refetchQueries(["lead"]);
        queryClient.refetchQueries(["vehicles"]);
        queryClient.refetchQueries(["parts"]);

      },
    }
  );

  const createWithPart = useMutation(
    (job: CreateJobWithPartRequest) => post(`/job/part`, job),
    {
      onSuccess: () => {
        queryClient.refetchQueries(["jobs"]);
        queryClient.refetchQueries(["lead"]);
        queryClient.refetchQueries(["vehicles"]);
        queryClient.refetchQueries(["parts"]);

      },
    }
  );

  const update = useMutation(
    (job: IJob) => put(`/job/${job.id}`, job),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["jobs"]);
      },
    }
  );

  const remove = useMutation(
    (id: string) => del(`/job/${id}`),
    {
      onSuccess: () => {
        queryClient.refetchQueries(["jobs"]);
        queryClient.refetchQueries(["lead"]);
        queryClient.refetchQueries(["vehicles"]);
        queryClient.refetchQueries(["parts"]);
      },
    }
  );

  return {
    jobs,
    create,
    createWithPart,
    update,
    remove
  };
}
